import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down_white",
  "use": "icon-arrow_down_white-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-arrow_down_white\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h18v18H0z\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M9 12 4.757 7.757l1.415-1.414L9 9.172l2.828-2.829 1.415 1.414z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol